import axios from 'axios'

const state = {
  currenciesList: [],
}

const getters = {
  currenciesList: state => state.currenciesList,
}

const actions = {
  async getCitiesList({ commit }) {
    await axios.get('currency/all/').then(response => {
      commit('SET_CURRENCY_LIST', response.data)
    })
  },
}

const mutations = {
  SET_CURRENCY_LIST: (state, data) => {
    state.currenciesList = data
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}
